import AllActions from "@/infrastructure/rootAction";
import produce from "immer";
import { getType } from "typesafe-actions";
import * as A from "./actions";
import * as IntType from "./types";

const defaultState: IntType.Store = {
  sidebarCollapsed: true,
  presentMode: false,
  isFullScreen: false
};

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.setSidebarCollapsed): {
        draft.sidebarCollapsed = action.payload;
        break;
      }

      case getType(A.setPresentMode): {
        draft.presentMode = action.payload;
        break;
      }

      case getType(A.setFullScreen): {
        draft.isFullScreen = action.payload;
        break;
      }
    }
  });
